import { useEffect, useState } from "react";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";

const useScrollToTopButton2Logic = () => {
  const [scrollBahevior, setScrollBahevior] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const scrolledValue = 300;
  const { theme } = useGlobalStyles();

  useEffect(() => {
    const borderOnScroll = document.getElementById(
      "canva-line",
    ) as HTMLCanvasElement;
    if (!borderOnScroll) return;
    const createCanvasLine = borderOnScroll.getContext("2d");
    if (!createCanvasLine) return;
    createCanvasLine.clearRect(
      0,
      0,
      borderOnScroll.width,
      borderOnScroll.height,
    );

    const screenBehaviorValue = (percentage * 2) / 100 - 0.5;

    const borderColor = theme.themeColors.button
      ? theme.themeColors.button
      : "#4C42F6";

    createCanvasLine.beginPath();
    createCanvasLine.strokeStyle = borderColor;
    createCanvasLine.lineWidth = 2;
    createCanvasLine.lineCap = "round";
    createCanvasLine.lineJoin = "round";
    createCanvasLine.imageSmoothingQuality = "high";
    createCanvasLine.shadowBlur = 10;
    createCanvasLine.closePath();
    createCanvasLine.arc(
      23,
      23,
      22,
      -0.5 * Math.PI,
      screenBehaviorValue * Math.PI,
    );
    createCanvasLine.stroke();
  }, [percentage]);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const onScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const scrollTop = window.scrollY;
        const documentHeight = document.body.offsetHeight;
        const windowHeight = window.innerHeight;
        const scrollPercent = scrollTop / (documentHeight - windowHeight);
        const scrollPercentRounded = Math.round(scrollPercent * 100);
        setPercentage(scrollPercentRounded);
        setScrollBahevior(window.scrollY > scrolledValue);
      }, 10);
    };
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [scrollBahevior]);

  return { scrollBahevior, setScrollBahevior, scrolledValue, percentage };
};

export default useScrollToTopButton2Logic;
